import requester from 'utils/requester';
import api from 'config/api';
import { LIST_MAX_SIZE as ITEMS_PER_REQUEST } from 'config';
import urlHelper from 'helpers/urlhelper';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';
import * as types from './types';
import Platform from 'platform';

export const fetchSearch = (query) => async (dispatch, getState) => {
  dispatch({ type: types.FETCH, payload: query });

  const isLoggedIn = getIsLoggedInSelector(getState());
  const endpointVod = urlHelper.getAuthorizedEndpointUrl(api.endpoints.searchVodPublic, isLoggedIn);
  const endpointChannels = urlHelper.getAuthorizedEndpointUrl(api.endpoints.searchChannelPublic, isLoggedIn);

  try {
    const channelSearchResults = await requester({
      method: 'get',
      url: `${api.host}${endpointChannels}`,
      params: {
        f_title: query,
        size: ITEMS_PER_REQUEST,
        page: 0,
        detailed: true,
        includeVod: true,
        visibilityRights: 'PREVIEW',
      },
      appendParams: true,
    });

    const vodSearchResults = await requester({
      method: 'get',
      url: `${api.host}${endpointVod}`,
      appendParams: false,
      params: {
        type: 'ALL',
        f_parent: 'isNull',
        f_epgEventState: 'CATCHUP',
        'f_metadata.contentType': 'not(EPISODE)',
        sort: 'relevance,videoContent',
        f_deviceType: Platform.getDeviceType(),
        'f_tenants.id': 1,
        'f_title.titleORtitle.titleBriefORtitle.summaryShortORtitle.summaryLong': query,
        searchMetadata: true,
        size: ITEMS_PER_REQUEST,
        page: 0,
        detailed: true,
        includeVod: true,
      },
    });

    const mergeResults = channelSearchResults;
    if (vodSearchResults.content.length) {
      mergeResults.content = mergeResults.content.concat(vodSearchResults.content);
    }
    mergeResults.totalElements += vodSearchResults.totalElements;
    mergeResults.totalPages += vodSearchResults.totalPages;

    const { content, totalElements } = mergeResults;

    const { query: currentQuery } = getState().search;
    /* Когда пользователь последовательно вводит символы может начаттся "гонка" запросов
     * на каждый ввод нового символа.
     * Для избежания перезаписи результата ответом на прошлый запрос (он мог позже вернуться)
     * нужно проверить, что "query" по которому был ответ все еще соответствует
     * текущему "query" в сторе.
     */
    if (query !== currentQuery) return;
    dispatch(onFetchSuccess({ content, totalElements, page: 0 }));
  } catch (error) {
    dispatch(onFetchError(error));
  }
};

const onFetchSuccess = (payload) => ({
  type: types.FETCH_SUCCESS,
  payload,
});

const onFetchError = (payload) => ({
  type: types.FETCH_ERROR,
  payload,
});

export const resetSearchQuery = (payload) => ({
  type: types.RESET_QUERY,
  payload,
});
